import { makeStyles } from "@material-ui/core";
import { createStyles, Theme } from "@material-ui/core/styles";
import React from "react";
import { TestRequestDisplayedState } from "../../components/Chip/StatusChip";
import { StatusFilterState, useStatusFilter } from "../../contexts/StatusFilterContext";
import formatIdentifierAsString from "../../functions/formatIdentifierAsString.function";
import FilterTile from "./FilterTile";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    filters__container: {
      marginBlockEnd: 0,
      marginBlockStart: 0,
      paddingInlineStart: 0,
      listStyleType: "none",

      "& > *": {
        marginInlineEnd: theme.spacing(2),
      },
    },
    filters__item: { display: "inline-block" },
  }),
);

export interface TestRequestDisplayedStateCount {
  state: TestRequestDisplayedState;
  total: number;
}
export interface StatusFilterProps {
  initialState?: StatusFilterState;
  statusCount: TestRequestDisplayedStateCount[] | null;
}

const StatusFilter: React.FC<StatusFilterProps> = ({ initialState, statusCount }) => {
  const { handleFilterChange: handleChange, statusFilterState: filterState } = useStatusFilter(initialState);
  const classes = useStyles();

  return (
    <>
      {statusCount && (
        <ul className={classes.filters__container}>
          {statusCount.map(({ state, total }) => {
            const isActive = filterState[state];
            const show = total > 0 || isActive;

            return (
              show && (
                <li className={classes.filters__item} key={state}>
                  <FilterTile
                    handleChange={handleChange}
                    isActive={isActive}
                    matches={total}
                    status={{
                      state,
                      label: formatIdentifierAsString(state),
                    }}
                  />
                </li>
              )
            );
          })}
        </ul>
      )}
    </>
  );
};

export default StatusFilter;
